module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-scottsville-white.5cafd97f.svg";